import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <Container className="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
                    <div className="p-5 shadow-lg rounded bg-white">
                        <h1 className="text-danger mb-4">Something went wrong.</h1>
                        <p className="lead text-muted mb-4">
                            We're sorry, but an unexpected error has occurred.
                        </p>
                        <Alert variant="danger" className="text-start overflow-auto" style={{ maxHeight: '200px' }}>
                            <small>{this.state.error && this.state.error.toString()}</small>
                        </Alert>
                        <Button
                            variant="primary"
                            onClick={() => window.location.href = '/'}
                            className="mt-3 px-4 py-2 rounded-pill fw-bold"
                        >
                            Return to Home
                        </Button>
                    </div>
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
